import URLConfig from '@Config/urls/url.config';
import {
  Route
} from 'react-router-dom';
// Admin Module
import * as ArchivingModule from '@Modules/admin/archiving/pages';
import * as BasicSettingsModule from '@Modules/admin/basicSettings/pages';
import * as IntegrationSettingsModulePages from '@Modules/admin/integrationSettings/pages';
import * as AdminModulePages from '@Modules/admin/pages';
import * as AdminUsersModulePages from '@Modules/admin/users/pages';
import basicSettingsRoutes from './basicSettings/BasicSettingsRoutes';
import integrationSettingsRoutes from './integrationSettings/IntegrationSettingsRoutes';
import adminUsersRoutes from './users/AdminUsersRoutes';
import React from 'react';
import archivingRoutes from './archiving/ArchivingRoutes';

const adminModuleRoutes = [
  <Route
    path={URLConfig.ADMIN.ROOT}
    element={<AdminModulePages.AdminHome />}
  />,

  // Archiving Routes

  <Route
    path={URLConfig.ADMIN.ARCHIVING.ROOT}
    element={<ArchivingModule.ArchivingLayout />}
  >
    {archivingRoutes.map((aroute, index) => React.cloneElement(aroute, { key: index}))}
  </Route>,

  // BASE_SETTINGS Routes

  <Route
    path={URLConfig.ADMIN.BASE_SETTINGS.ROOT}
    element={<BasicSettingsModule.BasicSettingsLayout />}
  >
    {basicSettingsRoutes.map((broute, index) => React.cloneElement(broute, { key: index}))}
  </Route>,

  // Integration settings Routes
  <Route
    path={URLConfig.ADMIN.INTEGRATION_SETTINGS.ROOT}
    element={<IntegrationSettingsModulePages.IntegrationSettingsLayout />}
  >
    {integrationSettingsRoutes.map((iroute, index) => React.cloneElement(iroute, {key: index}) ) }
  </Route>,

  // Users Routes
  <Route
    path={URLConfig.ADMIN.USERS.ROOT}
    element={<AdminUsersModulePages.AdminUsersLayout />}
  >
    {adminUsersRoutes.map((uroute, index) => React.cloneElement(uroute, {key: index}))}
  </Route>,
];

export default adminModuleRoutes;
